export const en = {
    'mc-banner-recommendation-text': 'To save the ad group, specify keywords',
    'performance-recommendation-text': 'To save the group, manually set impression criteria',
    'tgo-recommendation-text': 'To save the group, enable autotargeting or manually set impression criteria'
};
